import { getFiles } from 'html-dir-content';

import { setDroppedFiles } from '../actions/App';

import { removeUnwantedFiles } from './Files';

const getDroppedItemsRecursively = async (items) => {
  const promises = [];
  Array.from(items).forEach((item) => {
    promises.push(getFiles(item, { recursive: true, withFullPath: true }));
  });

  return Promise.all(promises).then(results => [].concat(...results));
};

const isDirectory = async (file) => (
  new Promise((resolve) => {
    file.slice(0, 1).arrayBuffer()
      .then(
        () => resolve({ isDirectory: false, name: file.name }),
        () => resolve({ isDirectory: true, name: file.name }),
      );
  })
);

const getDroppedFilesRecursively = async (files) => {
  const promises = [];
  Array.from(files).forEach((file) => {
    promises.push(isDirectory(file));
  });

  return Promise.all(promises).then(results => [].concat(...results));
};

export const uploadFilesTarget = {
  drop(props, monitor) {
    if (monitor.didDrop()) {
      return;
    }

    const { files, items } = monitor.getItem();
    getDroppedItemsRecursively(items).then((fileItems) => {
      getDroppedFilesRecursively(files).then((droppedFiles) => {
        const droppedFolders = droppedFiles.filter(df => (df.isDirectory)).map(df => (df.name));
        props.dispatch(setDroppedFiles(removeUnwantedFiles(
          fileItems.concat(files.filter(f => (
            !droppedFolders.includes(f.name)
          ))),
        )));
      });
    });
  },
};
